import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-35",
  "use": "icon-sheet_icon-35-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-35\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M20.6 8.8v9.6A1.6 1.6 0 0119 20H4.6A1.6 1.6 0 013 18.4V8.8\" /><path stroke-linecap=\"round\" d=\"M11.8 11.2l2.4 2.4M9.4 13.6l2.4-2.4\" /><path stroke-linejoin=\"round\" d=\"M7 4h9.6l4 4.8H3z\" /><path stroke-linecap=\"round\" d=\"M11.8 11.559v5.6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol